import { render, staticRenderFns } from "./CompletionEstimate.vue?vue&type=template&id=2331de54"
import script from "./CompletionEstimate.vue?vue&type=script&lang=js"
export * from "./CompletionEstimate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports